export default function createHelpers({ fetch, history }) {
  return {
    fetch,
    history,
  };
}



// WEBPACK FOOTER //
// ./src/store/createHelpers.js